<template>
  <div class="wrapper" data-app>
    <div
      class="participant-info list-user"
      :style="{
        filter:
          objectData?.is_cancel !== 1 && objectData?.can_payment !== 1
            ? 'blur(0.7px)'
            : ''
      }"
    >
      <div style="display: flex; align-items: center;min-height:50px">
        <CheckBoxService style="flex-shrink: 0;" :item="objectData" />
        <el-avatar
          :size="large"
          :src="objectData?.avatar"
          class="avatar"
        ></el-avatar>
        <div style="margin-left: 10px">
          <span class="participant-name">{{
            objectData?.fullname || objectData?.name_out_system
          }}</span>
          <span v-if="objectData.id > 0" class="participant-vid">{{
            objectData?.id
          }}</span>
        </div>
      </div>
      <div style="text-align: right; flex-shrink: 0;">
        <span class="participant-price" style="margin-left: auto"
          >{{ formatNumber(objectData?.amount) }} đ</span
        >
        <div style="display: flex">
          <div
            v-for="(pack, ixd) in objectData.pack_name || []"
            :key="ixd"
            style="margin-left: 3px"
          >
            <div style="display: flex">
              <img :src="icons.iconPack" width="8px" />
              <span class="participant-price" style="margin-left: 2px"
                >{{ pack }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatNumber } from "@/plugins/init";

import iconPack from "@/assets/img/svg/pack.svg";
import { decodeToken } from "@/utils/auth";
import { getBackGround } from "@/utils/wapAuth";
import CheckBoxService from "@/views/pages/wapV2/history/components/CheckBoxService.vue";
export default {
  components: {
    CheckBoxService
  }, //, Comment
  bodyClass: "data-booking-services",
  props: {
    objectData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      bg: getBackGround(),
      checked: false,
      large: "large",
      isShow: [],
      icons: {
        iconPack
      },
      form: {}
    };
  },
  created() {},

  watch: {},

  methods: {
    decodeToken,
    formatNumber
  },
  computed: {},
  mounted() {},

  beforeDestroy() {}
};
</script>
<style lang="scss" scoped>
.checkbox {
  margin-left: 2px;
}

.quantity,
.status {
  display: block;
  font-size: 14px;
  font-weight: 400;
}

.price {
  font-size: 14px;
  color: #fb7800;
  display: block;
}

.participant-info {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  border-radius: 8px;
  padding: 3px 10px;
  margin-bottom: 5px;
}

.avatar {
  margin-left: 10px;
}

.participant-details {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.participant-name {
  display: block;
  font-size: 14px;
  color: #000;
  font-weight: 400;
}
.participant-vid {
  line-height: 1;
  display: block;
  font-size: 12px;
  color: #000;
  font-weight: 400;
}

.participant-price {
  line-height: 1.2;
  max-width: 200px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  font-size: 14px;
  color: #000;
  font-weight: 400;
}

.divider {
  //position: absolute;
  left: 0;
  right: 0;
  margin: 10px 0;
}

.content {
  margin-right: 12px;
  margin-left: 12px;
}

.value1 {
  font-size: 16px;
  font-weight: 600;
  color: #fb7800;
}
.value2 {
  font-size: 14px;
  font-weight: 400;
  color: #0095da;
}
.el-checkbox__inner {
  border-radius: 50% !important;
}

.mobile {
  display: none;
}
@media screen and (min-width: 0px) and (max-width: 769px) {
  .header-top {
    padding-top: 60px !important;
  }
  .desktop {
    display: none;
  }
  .mobile {
    display: block;
  }
}
</style>

<style lang="scss">
@media screen and (min-width: 0px) and (max-width: 769px) {
}

.mt-0 {
  margin-top: 0 !important;
}

.pointer {
  cursor: pointer;
}

.border-1 {
  border: 1px solid #ababab;
  border-radius: 10px;
}

.icon-image {
  height: 30px !important;
}

.text-not-break {
  word-break: keep-all !important;
}
</style>
